module.exports = __webpack_public_path__ + "img/map-brasil.02921606.jpg";